<template>
  <div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="data"
        class="va-table va-table--hoverable va-table--clickable"
        api-mode
      >
        <template slot="id" slot-scope="props">
          <span>{{ props.rowData.id }}</span>
        </template>
        <template slot="name" slot-scope="props">
          <span>{{ props.rowData.name }}</span>
        </template>
        <template slot="price" slot-scope="props">
          <span>{{ props.rowData.price }}</span>
        </template>
        <template slot="qty" slot-scope="props">
          <span>{{ props.rowData.qty }}</span>
        </template>

        <template slot="actions" slot-scope="props">
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-pencil"
            @click="update(props.rowData)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-trash"
            @click="remove(props.rowData.id)"
          />
        </template>
      </va-data-table>
    </va-card>
    <va-modal v-model="updateModal" size="large" hide-default-actions>
      <update
        :product-info="productInfo"
        @hide="updateModal = false"
        @neeFetch="fetchAdditionalProducts"
      />
    </va-modal>
  </div>
</template>

<script>
import api from "@/api/axios";
import update from "./update.vue";
export default {
  components: { update },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      updateModal: false,
      productInfo: null,
    };
  },
  methods: {
    async remove(additionalProductId) {
      if (confirm("Вы действительно хотите удалить ?")) {
        try {
          await api.delete("admin/additional-products/" + additionalProductId);
          this.$emit("neeFetch");
        } catch (error) {
          return error;
        }
      }
    },
    update(productInfo) {
      this.updateModal = true;
      this.productInfo = productInfo;
    },
    fetchAdditionalProducts() {
      this.$emit("neeFetch");
    },
  },
  computed: {
    fields() {
      return [
        {
          name: "__slot:id",
          title: "Номер",
        },
        {
          name: "__slot:name",
          title: "Название",
        },
        {
          name: "__slot:price",
          title: "Цена",
        },
        {
          name: "__slot:qty",
          title: "Кол-во",
        },
        {
          name: "__slot:actions",
          title: "",
        },
      ];
    },
  },
};
</script>